import { useState } from 'react'
import { CONTENT_TOPICS } from '../../constants/Constants'
import '../../styles/content/readyToGoContent.css'
import { ReactComponent as PolygonLeft } from '../../assets/svg/PoligonLeft.svg'
import { useTranslation } from 'react-i18next'

const PAGE_SIZE = 4

const ContentTopicButtons = ({ selectedTopic = 'generalWellbeing', selectTopic = () => {} }) => {
    const [endContentIndex, setEndContentIndex] = useState(PAGE_SIZE)
    const { t } = useTranslation()

    const disableRight = endContentIndex >= CONTENT_TOPICS.length
    const disableLeft = endContentIndex - PAGE_SIZE <= 0

    const goNext = () => {
        if (disableRight) return
        setEndContentIndex((prev) => prev + 1)
    }
    const goPrevious = () => {
        if (disableLeft) return
        setEndContentIndex((prev) => prev - 1)
    }

    return (
        <div className="rtg-topic-row flex flex-row items-center">
            <button type="button" className="left-button" onClick={goPrevious} disabled={disableLeft} aria-label={t('Previous')}>
                <PolygonLeft fill={disableLeft ? 'white' : '#9392AD'} />
            </button>
            <div className="flex flex-1 min-w-0 flex-row gap-[10px] mx-[10px]">
                {CONTENT_TOPICS.slice(endContentIndex - PAGE_SIZE, endContentIndex).map((contentType) => {
                    const isSelected = contentType.code === selectedTopic
                    return (
                        <button
                            type="button"
                            key={contentType.code}
                            className={`content-topic-button relative min-w-0 ${contentType.cssClass}`}
                            aria-pressed={isSelected}
                            style={{
                                backgroundColor: isSelected ? contentType.color : 'white',
                                borderColor: isSelected ? 'transparent' : contentType.color,
                            }}
                            onClick={() => selectTopic(contentType.code)}
                        >
                            <div className="mb-[8px] flex flex-row items-center">
                                {contentType.icon}
                                <p className="content-topic-button-title">{t(contentType?.name)}</p>
                            </div>
                            <p className="content-topic-button-description">{t(contentType?.description)}</p>
                            {isSelected && <div className="w-0 h-0 absolute selected-topic-arrow" style={{ borderTopColor: contentType.color }}></div>}
                        </button>
                    )
                })}
            </div>
            <button type="button" className="left-button rotate-180" onClick={goNext} disabled={disableRight} aria-label={t('next')}>
                <PolygonLeft fill={disableRight ? 'white' : '#9392AD'} />
            </button>
        </div>
    )
}

export default ContentTopicButtons
